import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Header from "./components/Header";
import Home from "./components/Home";
import Footer from "./components/Footer";
import Contact from "./components/Contact";
import Services from "./components/Services";

import "./style/app.css";
import"./style/Header.css"; 
import "./style/Home.css";
import "./style/footer.css";
import "./style/contact.css";
import "./style/media.css"

function App() {
  return (
    <Router>
      <Header />
        <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/Contact" element={<Contact />} />
            <Route path="/Services" element={<Services />} />
        </Routes>
        <Footer/>
    </Router>
  )
}

export default App;